import { Link } from "react-router-dom";

import { ROUTES } from "@/shared/model/routes";

import Logo from "./logo";

const buyerLinks = [
  { label: "Каталог", route: ROUTES.PRODUCTS },
  { label: "Как купить", route: ROUTES.USER_HOW_TO_BUY },
  { label: "Гарантии", route: ROUTES.USER_GUARANTEES },
  { label: "Правила", route: ROUTES.USER_RULES },
];

const storeLinks = [
  { label: "Стать продавцом", route: ROUTES.STORE_BECOME_STORE },
  { label: "Гарантии", route: ROUTES.STORE_GUARANTEES },
  { label: "Правила", route: ROUTES.STORE_RULES },
  { label: "Комиссия", route: ROUTES.STORE_COMMISSION },
];

interface FooterProps {
  className?: string;
}

const Footer = ({ className }: FooterProps) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`border-t bg-background z-10 ${className ?? ""}`.trim()}>
      <div className="container mx-auto py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-end gap-2 mb-2">
              <Logo />
              <span className="text-xs text-muted-foreground">
                v{__RELEASE_VERSION__}
              </span>
            </div>
            <p className="text-muted-foreground text-sm leading-relaxed">
              Безопасная площадка для покупки и продажи цифровых аккаунтов.
            </p>
          </div>

          {/* Links */}
          <div className="md:pl-24">
            <h3 className="font-semibold text-sm mb-4">Покупателям</h3>
            <ul className="space-y-3 text-sm text-muted-foreground">
              {buyerLinks.map((item) => (
                <li key={item.route}>
                  <Link
                    to={item.route}
                    className="hover:text-foreground transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:pl-12">
            <h3 className="font-semibold text-sm mb-4">Продавцам</h3>
            <ul className="space-y-3 text-sm text-muted-foreground">
              {storeLinks.map((item) => (
                <li key={item.route}>
                  <Link
                    to={item.route}
                    className="hover:text-foreground transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t  mt-12 pt-8 flex flex-col md:flex-row items-center md:justify-between gap-4 text-sm text-muted-foreground text-center md:text-left">
          <div>© {currentYear} Monument. Все права защищены.</div>
          <div className="flex flex-col md:flex-row gap-4 md:gap-6">
            <Link
              to={ROUTES.PRIVACY_POLICY}
              className="hover:text-foreground transition-colors"
            >
              Политика конфиденциальности
            </Link>
            <Link
              to={ROUTES.TERMS_OF_USE}
              className="hover:text-foreground transition-colors"
            >
              Условия использования
            </Link>
            <Link
              to={ROUTES.TERMS_AND_CONDITIONS}
              className="hover:text-foreground transition-colors"
            >
              Условия и положения
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
